import { connect, useDispatch } from "react-redux";
import {
  ISubStepData,
  ISubStepIndex,
} from "../../../../../models/freshman/subStep";
import { setSubSteps } from "../../../../../store/slices/common/commonSlice";
import { useState, useEffect } from "react";
import LoaderSpinner from "../../../../../common-components/loader";
import {
  getSubStep,
  getSubSteps,
  inactivateSubStep,
} from "../../../../../action/freshman/subStepActionCreator";
import ReactModal from "react-modal";
import SubStepCreate from "./subStepCreate";
import {
  alertConstants,
  getAlertData,
} from "../../../../../helper/sweet-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import SubStepEdit from "./subStepEdit";

const SubStepIndex = (props: ISubStepIndex) => {
  const { getSubSteps, subSteps, getSubStep, subStep, inactivateSubStep } =
    props;

  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [isInactive, setIsInactive] = useState<boolean>(false);
  const [itemToDelete, setItemToDelete] = useState<number>(0);
  const [errors, setErrors] = useState<any>(undefined);
  const [showAlert, setShowAlert] = useState<boolean>(false);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isEditLoading, setIsEditLoading] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handleCreateOpen = () => setShowCreate(true);
  const handleCreateClose = () => setShowCreate(false);
  const handleEditOpen = () => setShowEdit(true);
  const handleEditClose = () => setShowEdit(false);

  const editItem = async (id: number) => {
    handleEditOpen();
    setIsEditLoading(true);
    try {
      await getSubStep(id);
    } finally {
      setIsEditLoading(false);
    }
  };

  // executes when delete button is clicked
  const deleteItem = (id: number) => {
    setIsInactive(true);
    setAlert(alertConstants.inactiveCheck);
    setItemToDelete(id);
  };

  const onConfirm = () => {
    if (alertType === alertConstants.error) {
      setShowAlert(false);
    } else if (isInactive === true) {
      setShowAlert(false);
      setIsInactive(false);
      inactivateSubStep(itemToDelete, setAlert);
    } else {
      setShowAlert(false);
      setIsInactive(false);
      getAllSubSteps();
    }
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setShowAlert(true);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAllSubSteps = async () => {
    setIsLoading(true);
    try {
      await getSubSteps(true);
    } finally {
      setIsLoading(false);
    }
  };

  console.log(subSteps);

  useEffect(() => {
    getAllSubSteps();
    return () => {
      dispatch(setSubSteps([]));
    };
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Sub Task</h2>
          <a
            className="btn btn-primary"
            onClick={() => {
              handleCreateOpen();
            }}
          >
            <img src="/assets/images/icon/plus.svg" alt="" className="me-2" />
            Add New
          </a>
        </div>
        <ul className="d-flex gap-3 flex-wrap mt-28">
          {isLoading ? (
            <LoaderSpinner />
          ) : subSteps && subSteps.length > 0 ? (
            subSteps.map((subStep: ISubStepData) => {
              return (
                <li
                  className="admin-card"
                  style={{
                    pointerEvents: !subStep.isActive ? "none" : "auto",
                    opacity: !subStep.isActive ? 0.5 : 1,
                  }}
                  key={subStep.id}
                >
                  <div className="top">
                    <div className="btn-flex">
                      <button
                        className="btn-edit"
                        onClick={() => editItem(subStep.id ?? 0)}
                      >
                        <img src="/assets/images/icon/edit-wh.svg" alt="" />
                      </button>
                      <button
                        className="btn-delete"
                        onClick={() => deleteItem(subStep.id ?? 0)}
                      >
                        <img src="/assets/images/icon/trash-wh.svg" alt="" />
                      </button>
                    </div>
                  </div>

                  <div className="btm">
                    <h2 className="para-hide-1">{subStep?.name}</h2>
                    <p className="para-hide-1">{subStep?.description}</p>
                  </div>
                </li>
              );
            })
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
      <ReactModal
        isOpen={showCreate}
        onRequestClose={handleCreateClose}
        className="react-modal-content"
        overlayClassName="react-modal-overlay"
        shouldCloseOnOverlayClick={false}
      >
        <SubStepCreate
          setShowCreate={handleCreateClose}
          getAllSubSteps={() => getAllSubSteps()}
        />
      </ReactModal>

      {isEditLoading ? (
        <LoaderSpinner />
      ) : (
        <ReactModal
          isOpen={showEdit}
          onRequestClose={handleEditClose}
          className="react-modal-content"
          overlayClassName="react-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <SubStepEdit
            setShowEdit={handleEditClose}
            getAllSubSteps={() => getAllSubSteps()}
            subStep={subStep}
          />
        </ReactModal>
      )}

      <SweetAlert
        show={showAlert}
        success={false}
        type={alertType}
        title={alertTitle}
        onConfirm={() => onConfirm()}
        showCancel={isInactive}
        onCancel={() => {
          setShowAlert(false);
          setIsInactive(false);
        }}
        cancelBtnText={"No"}
        confirmBtnText={isInactive ? "Yes" : "Ok"}
      />
    </>
  );
};

const mapDispatchToProps = {
  getSubSteps: (includeInactive?:boolean) => getSubSteps(includeInactive),
  getSubStep: (id: number) => getSubStep(id),
  inactivateSubStep: (id: number, callBack: Function) =>
    inactivateSubStep(id, callBack),
};

function mapStateToProps(state: any) {
  return {
    subSteps: state.subStep.subSteps,
    subStep: state.subStep.subStep,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SubStepIndex);
